<template>
    <div class="w-full">

        <slide-over-panel     v-if="selectedCharacteristic !== null"
                        v-model:show="showCharacteristicHistory">
            <template   #title>
                History for {{ characteristics[selectedCharacteristic].characteristic }}
            </template>

            <template   #content>
                <div    class="">
                    <characteristic-history     :characteristic="characteristics[selectedCharacteristic]">

                    </characteristic-history>
                </div>
            </template>
        </slide-over-panel>

        <ajax-table     :data="characteristics"
                        :headers="headers"
                        v-model:loading="ajaxTable.loading"
                        v-model:search="ajaxTable.search"
                        v-model:sort-by="ajaxTable.sortBy"
                        v-model:sort-desc="ajaxTable.sortDesc"
                        v-model:page="ajaxTable.page"
                        v-model:items-per-page="ajaxTable.itemsPerPage"
                        v-model:page-info="ajaxTable.pageInfo"
                        :exportable="false"
                        @loadData="getData"
                        @rowSelected="showHistoryModal">
            <template   #items-per-page>
                <div></div>
            </template>
        </ajax-table>
    </div>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import AjaxTable from "@/components/elements/AjaxTable";
import SlideOverPanel from "@/components/elements/SlideOverPanel";
import TailwindTable from "@/components/elements/TailwindTable";
import CharacteristicHistory from "@/components/DevicePortal/CharacteristicHistory";
import SmallColoredCheck from "@/components/elements/SmallColoredCheck";

export default {
    name: "DeviceProfileShow",
    mixins: [SonicuCoreMixin, iconNamesMixin, ajaxTableMixin],
    components: {SmallColoredCheck, CharacteristicHistory, TailwindTable, SlideOverPanel, AjaxTable},
    props: {
        pointSerial: String,
    },
    data() {
        return {
            characteristics: [],
            headers: [
                {
                    name: 'Characteristic',
                    key: 'characteristic',
                    sortBy: 'characteristic',
                },
                {
                    name: 'Value',
                    key: 'prettyValue',
                    sortBy: '',
                },
                {
                    name: 'Updated By',
                    key: 'updatedBy',
                    sortBy: 'updatedBy',
                    show: 'md'
                },
                {
                    name: 'Updated On',
                    key: 'updatedOn',
                    sortBy: 'updatedOn',
                    show: 'lg',
                },
            ],

            selectedCharacteristic: null,
            showCharacteristicHistory: false,
        }
    },
    created() {
        this.ajaxTable.itemsPerPage = "1000"
    },
    mounted() {

    },
    methods: {
        getData() {
            this.ajaxTable.loading = true
            this.ajaxTable.requestNumber++
            let params = this.ajaxTable
            axios.get(this.company.buildCompanyApiInternalRoute(`device-profile/${this.pointSerial}`), {
                params: params
            }).then(response => {
                let data = response.data
                if (data.meta.requestNumber !== `${this.ajaxTable.requestNumber}`) {
                    return
                }
                this.characteristics = data.data
            }).catch(error => {
                console.log(error)
            }).then(() => {
                this.ajaxTable.loading = false
            })
        },
        showHistoryModal(rowIndex) {
            this.selectedCharacteristic = rowIndex
            this.showCharacteristicHistory = true
        },
    },
    computed: {

    },
    watch: {
        pointSerial() {
            this.getData()
        }
    },
}
</script>

<style scoped>

</style>